// useRemoveChecklistTask.tsx
import { useMutation } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from 'context/SnackbarProvider/SnackbarProvider'

interface TaskToRemove {
  PK: any
  SK: any
  itemIndex: any
  sectionIndex: number
  itemId: any
}

export const useRemoveChecklistTask = () => {
  const { showSnackbar } = useSnackbarContext()

  return useMutation({
    mutationFn: async (taskToRemove: TaskToRemove) => {
      return axios.post(`${baseUrl}/aws/checklists/remove_task`, { task: taskToRemove })
    },
    onSuccess: ({ data }) => {
      console.log('✅ Task removed successfully.', data)
      showSnackbar(data?.message ?? 'Task removed successfully', 'success')
      // queryClient.invalidateQueries({ queryKey: ['checklists'] }) // Refresh checklist
    },
    onError: error => {
      console.error('❌ Error removing task:', error)
    },
  })
}
